var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.card.cardLabels && _vm.card.cardLabels.length
      ? _c(
          "div",
          { staticClass: "row mx-0" },
          _vm._l(_vm.card.cardLabels, function(label) {
            return _c("div", {
              key: label.id,
              staticClass: "label d-inline mr-1",
              style: { "background-color": label.label.colorTag }
            })
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }